(function () {
    "use strict";

    var IntegerParameterControl = Solovis.defineClass(
        "Solovis.Reports.Parameters.IntegerParameterControl",
        Solovis.UI.BaseControl,
        function (options) {
            this.initialParameterValue = (typeof options.initialValue != "undefined") ? options.initialValue : null;
        });


    IntegerParameterControl.getLabel = function (value): string | undefined {
        return value?.toString();
    };

    IntegerParameterControl.prototype.doInit = function () {
    };

    IntegerParameterControl.hasNewRender = true;

    IntegerParameterControl.prototype.doRender = function () {
        const enabled = (this.options as Solovis.UI.BaseControlOptions).renderMode === 'modern';
        if (enabled) {
            this.doRenderNew();
        } else {
            this.doRenderClassic();
        }
    }

    IntegerParameterControl.prototype.doRenderNew = async function () {
        var self = this;
        const target = this.container[0];
        const id = Solovis.UX.Utils.generateId();

        await Solovis.UX.Utils.placeComponent(
            "Input",
            target,
            {
                id,
                defaultValue: this.initialParameterValue,
                onChange: (value) => {
                    self.notifyParameterValueChanged();
                },
                placeholder: "Enter a numeric value",
                inputVariant: "number"
            }
        );

        this.textInput = $(`#${id}`);
    }

    IntegerParameterControl.prototype.doRenderClassic = function () {
        var self = this;

        this.container.addClass("report-param-integer");

        this.textInput = $("<input>").attr("type", "text").appendTo(this.container)
            .css("margin", 0).css("width", "100px");

        if (this.initialParameterValue !== null) {
            this.textInput.val(this.initialParameterValue);
        }

        $(this.textInput).change(function () {
            self.notifyParameterValueChanged();
        });
    };

    IntegerParameterControl.prototype.setParameterValue = function (newValue) {
        if (this.textInput) {
            // TODO: Determine if this will cause looping in events since we didn't want setParameterValue to trigger an event.
            this.textInput.val(newValue);
        }
        else {
            this.initialParameterValue = newValue;
        }
    };

    IntegerParameterControl.prototype.getParameterValue = function () {
        if (this.textInput) {
            var textValue = this.textInput.val();
            if(!textValue.length) {
                return null;
            }
            var intValue = parseInt(textValue, 10);

            return intValue;
        }
        else {
            return this.initialParameterValue;
        }
    };

    IntegerParameterControl.prototype.notifyParameterValueChanged = function () {
        $(this).trigger("parameterValueChanged");
    };

})();